// ====================================================================================
// stickyDonation.module
// ====================================================================================
import $ from "jquery";

const scrollStart = document.querySelector(".header")
  ? document.querySelector(".header").offsetHeight
  : 7;
const stickyDonation = {
  elem: document.querySelector(".sticky-donation"),
  staticContent: document.querySelector(".sticky-donation .static-content"),
  logo: document.querySelector(".sticky-donation .image-floated--2"),
  decor: document.querySelector(".sticky-donation .decor-3"),
  offsetTop: 0,
  sticky: true,
};

const updateImageHeight = () => {
  if (!stickyDonation.staticContent || !stickyDonation.logo) return;
  let sContentHeight = stickyDonation.staticContent.offsetHeight;
  stickyDonation.logo.style.height = sContentHeight + "px";
};

/**
 * Set offset of the next sibling element + padding bottom of the sticky donation element
 * Checks at first if the next element exists and is type of ELEMENT_NODE
 * (https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#node.element_node
 */
function setStickyDonationOffset() {
  let elem = stickyDonation.elem;
  let offset = 0;
  let elHeight = elem.offsetHeight;

  let tMargin = window.getComputedStyle(stickyDonation.elem).marginTop;
  tMargin = parseInt(tMargin.replace("px", ""));

  let bMargin = window.getComputedStyle(stickyDonation.elem).marginBottom;
  bMargin = parseInt(bMargin.replace("px", ""));

  let donationHeight = document.querySelector(
    ".sticky-donation .donation"
  ).offsetHeight;

  let $nextElem = $(elem).next();
  if ($nextElem.get(0) && $nextElem.get(0).nodeType === 1) {
    offset = $nextElem.offset().top - bMargin - elHeight + donationHeight;
  }
  stickyDonation.offsetTop = offset;
}

const handleStickyDonation = (sc) => {
  if (sc <= scrollStart) {
    $(stickyDonation.elem).removeClass("sticky");
    stickyDonation.sticky = false;
    $(stickyDonation.elem).addClass("init");
    return;
  } else {
    $(stickyDonation.elem).addClass("init");
  }

  let stickyPoint = stickyDonation.offsetTop;
  let scrollHeight = sc + window.innerHeight;
  if (scrollHeight > stickyPoint && stickyDonation.sticky) {
    $(stickyDonation.elem).removeClass("sticky");
    stickyDonation.sticky = false;
  } else if (scrollHeight <= stickyPoint && !stickyDonation.sticky) {
    $(stickyDonation.elem).addClass("sticky");
    stickyDonation.sticky = true;
  }
};

export const init = () => {
  let attempts = 0;
  let notSticky = stickyDonation.elem.classList.contains("not-sticky");
  let noDecor = !stickyDonation.decor;

  if (notSticky) {
    $(stickyDonation.elem).addClass("init");
  } else {
    $(stickyDonation.elem).removeClass("init");
  }

  const whenComplete = () => {
    if (++attempts > 30) return;
    if (document.readyState === "complete") {
      if (notSticky && noDecor) {
        updateImageHeight();

        $(window).on("resize", function (e) {
          updateImageHeight();
        });
      } else {
        setStickyDonationOffset();
        setTimeout(() => setStickyDonationOffset(), 500);
        let bsc = window.scrollY || window.pageYOffset;
        handleStickyDonation(bsc);
        if (noDecor) updateImageHeight();

        $(window).on("scroll", function (e) {
          let sc = window.scrollY || window.pageYOffset;
          handleStickyDonation(sc);
        });

        $(window).on("resize", function (e) {
          if (noDecor) updateImageHeight();
          if (stickyDonation) setStickyDonationOffset();
        });
      }
    } else {
      setTimeout(() => whenComplete(), 400);
    }
  };

  whenComplete();
};
